import { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/AppIcon';

interface InterimNoticeProps {
  className?: string;
}

const InterimNotice = ({ className = '' }: InterimNoticeProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const noticeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (noticeRef.current) {
      observer.observe(noticeRef.current);
    }

    return () => {
      if (noticeRef.current) {
        observer.unobserve(noticeRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={noticeRef}
      className={`relative py-12 px-6 ${className}`}
    >
      <div
        className={`container mx-auto max-w-4xl transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="glass-effect rounded-lg p-8 border-l-4 border-primary">
          <div className="flex items-start space-x-4">
            <Icon name="Info" size={24} className="text-primary flex-shrink-0 mt-1" />
            <div className="space-y-3">
              <h3 className="text-xl font-semibold text-foreground">
                Interim Website Notice
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                This landing page represents a subset of Dhavaja's full capabilities. Our comprehensive platform featuring detailed case studies, complete technical documentation, and expanded service portfolio is currently under development and will launch soon.
              </p>
              <p className="text-sm text-muted-foreground">
                For immediate project inquiries, please use the contact form below or reach out directly via email.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterimNotice;